module.exports = __webpack_public_path__ + "static/media/n16.6d529cff.jpg";